import { Buttons } from "../../../generic-sprites/Buttons"
import { CameraZoom, ZoomTarget } from "../../../utils/CameraZoom"
import { Scale } from "../../../utils/Scale"
import { Sprites } from "../../../utils/Sprites"
import { KidsChoiceAudio, KidsChoiceImages } from "../KidsChoiceAssets"
import { KidsChoicePartOneState } from "../KidsChoicePartOneState"

export class KidsChoiceTheater {
    isPartOne: boolean
    private readonly left: Phaser.Sprite
    private readonly right: Phaser.Sprite
    private readonly start: Phaser.Sprite


    constructor(private game: Phaser.Game, isPartOne: boolean, private onZoom: () => void, private group: Phaser.Group) {
        const curtainY = Scale.y(-0.234)
        const curtainX = Scale.x(-0.15)
        this.left = Sprites.add(this.game, KidsChoiceImages.LEFT_CURTAIN, {debug: true, x: curtainX, y: curtainY, group})
        this.right = Sprites.add(this.game, KidsChoiceImages.RIGHT_CURTAIN, {debug: true, x: curtainX + this.left.width, y: curtainY, group})
        const frame = Sprites.add(this.game, KidsChoiceImages.FRAME, {x: Scale.x(0), y: Scale.y(0), group})
        this.start = Sprites.add(this.game, KidsChoiceImages.START, {debug: true, group})
        Sprites.centerSpriteInSprite(frame, this.start)
        this.isPartOne = isPartOne
    }

    startIntroSequence = () => {
        const audioFile = this.isPartOne ? KidsChoiceAudio.INTRO : KidsChoiceAudio.INTRO_2
        const audio = this.game.add.audio(audioFile)
        audio.onPlay.add(() => {
            if (this.isPartOne) {
                this.zoomFunction()
            } else {
                setTimeout(this.zoomFunction, 10000)
            }
        })
        audio.onStop.add(() => Buttons.makeSpriteButton(this.start, this.startOnClick))
        audio.play()
    }

    private startOnClick = () => {
        const delta = Scale.x(0.32)
        CameraZoom.moveSprite(this.left, this.left.x - delta, 0)
        const tween = CameraZoom.moveSprite(this.right, this.right.x + delta, 0)
        tween.onStart.add(() => {
            this.start.destroy(true)
            this.onZoom()
        })
    }

    private zoomFunction = () => {
        const rect = KidsChoicePartOneState.centerRectangle
        CameraZoom.zoom(this.game, new ZoomTarget(rect.x, rect.y, rect.width, rect.height))
    }
}